export const text = {
  title: 'Unaccepted Requests',
};
